import React, { FC, useState } from 'react';
import styles from './input_search.module.scss';

type Props = React.HTMLProps<HTMLInputElement>;

export const InputSearch: FC<Props> = (props) => {
  const [focus, setFocus] = useState(false);
  const handleFocusAndBlur = () => {
    setFocus((prevState) => !prevState);
  };
  return (
    <div className={`${styles.group} ${focus ? styles.focus : styles.blur}`}>
      <img className={styles.icon} src="/img/icons/search.svg" alt="search" />
      <input
        {...props}
        className={styles.input}
        onFocus={handleFocusAndBlur}
        onBlur={handleFocusAndBlur}
      />
    </div>
  );
};
